"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _identifiers = require("../identifiers");

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _function = _interopRequireDefault(require("empty/function"));

var _CalendlyForm = _interopRequireDefault(require("./CalendlyForm.view"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CALENDLY_URL_REGEX = /(https:\/\/calendly\.com)\/([a-z0-9-_@+]*)\/([a-z0-9]+)/g;
var CALENDLY_EVENT_TYPE_VIEWED = 'calendly.event_type_viewed';
var CALENDLY_DATE_AND_TIME_SELECTED = 'calendly.date_and_time_selected';
var CALENDLY_EVENT_SCHEDULED = 'calendly.event_scheduled';

var CalendlyFormController = /*#__PURE__*/function (_PureComponent) {
  _inherits(CalendlyFormController, _PureComponent);

  var _super = _createSuper(CalendlyFormController);

  function CalendlyFormController() {
    var _this;

    _classCallCheck(this, CalendlyFormController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "calendlyEventHistory", []);

    _defineProperty(_assertThisInitialized(_this), "handleFormSubmit", function (formData) {
      var _this$props = _this.props,
          onFormSubmit = _this$props.onFormSubmit,
          fallbackSubmitHandler = _this$props.fallbackSubmitHandler;

      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      if (!_this.urlValid) {
        fallbackSubmitHandler.apply(void 0, [formData].concat(params));
        return;
      }

      _this.openCalendlyPopup(formData);

      onFormSubmit.apply(void 0, [formData].concat(params));
    });

    _defineProperty(_assertThisInitialized(_this), "handleMissingCalendly", function () {
      var _this$props2;

      (_this$props2 = _this.props).onCalendlyFailed.apply(_this$props2, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "openCalendlyPopup", function (formData) {
      var Calendly = window.Calendly;

      if ((0, _isEmpty["default"])(Calendly)) {
        _this.handleMissingCalendly();
      } else {
        Calendly.initPopupWidget({
          url: _this.props.url,
          prefill: formData
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePopupClosed", function () {
      if (!_this.calendlyEventHistory.includes(CALENDLY_EVENT_SCHEDULED)) {
        var _this$props3;

        (_this$props3 = _this.props).onPopupCancelled.apply(_this$props3, arguments);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addClickHandlerToElement", function (className, handler) {
      var element = document.getElementsByClassName(className)[0];

      if (element) {
        element.addEventListener('click', handler);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEventTypeViewed", function () {
      _this.addClickHandlerToElement('calendly-popup-close', _this.handlePopupClosed);

      _this.addClickHandlerToElement('calendly-close-overlay', _this.handlePopupClosed);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEventScheduled", function () {
      var _this$props4 = _this.props,
          onEventScheduled = _this$props4.onEventScheduled,
          closeOnScheduled = _this$props4.closeOnScheduled;

      if (closeOnScheduled) {
        window.Calendly.closePopupWidget();
      }

      onEventScheduled.apply(void 0, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDateAndTimeSelected", function () {
      var onDateAndTimeSelected = _this.props.onDateAndTimeSelected;
      onDateAndTimeSelected.apply(void 0, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMessageEvent", function (event) {
      var eventName = (0, _get["default"])(event, 'data.event', '');
      var isCalendlyEvent = eventName.includes('calendly');

      if (isCalendlyEvent) {
        _this.calendlyEventHistory.push(eventName);

        switch (eventName) {
          case CALENDLY_EVENT_TYPE_VIEWED:
            _this.handleEventTypeViewed();

            break;

          case CALENDLY_EVENT_SCHEDULED:
            _this.handleEventScheduled();

            break;

          case CALENDLY_DATE_AND_TIME_SELECTED:
            _this.handleDateAndTimeSelected();

            break;

          default:
            break;
        }
      }
    });

    return _this;
  }

  _createClass(CalendlyFormController, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('message', this.handleMessageEvent);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handleMessageEvent);

      if (!(0, _isEmpty["default"])(window.Calendly)) {
        window.Calendly.closePopupWidget();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/_react["default"].createElement(_CalendlyForm["default"], {
        onSubmit: this.handleFormSubmit
      }, children);
    }
  }, {
    key: "urlValid",
    get: function get() {
      var url = this.props.url;
      return CALENDLY_URL_REGEX.test(url);
    }
  }]);

  return CalendlyFormController;
}(_react.PureComponent);

_defineProperty(CalendlyFormController, "displayName", _identifiers.CALENDLY_FORM);

CalendlyFormController.propTypes = {
  children: _propTypes["default"].node.isRequired,
  url: _propTypes["default"].string.isRequired,
  closeOnScheduled: _propTypes["default"].bool.isRequired,
  onFormSubmit: _propTypes["default"].func.isRequired,
  onPopupCancelled: _propTypes["default"].func.isRequired,
  onEventScheduled: _propTypes["default"].func.isRequired,
  onDateAndTimeSelected: _propTypes["default"].func.isRequired,
  onCalendlyFailed: _propTypes["default"].func.isRequired,
  calendlyEngageScript: _propTypes["default"].func.isRequired,
  fallbackSubmitHandler: _propTypes["default"].func.isRequired
};
CalendlyFormController.defaultProps = {
  children: null,
  url: '',
  closeOnScheduled: true,
  onFormSubmit: _function["default"],
  onPopupCancelled: _function["default"],
  onEventScheduled: _function["default"],
  onDateAndTimeSelected: _function["default"],
  onCalendlyFailed: _function["default"],
  calendlyEngageScript: _function["default"],
  fallbackSubmitHandler: _function["default"]
};
var _default = CalendlyFormController;
exports["default"] = _default;